/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-27 16:02:16
 * @LastEditors: K
 * @LastEditTime: 2022-10-09 09:27:30
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Form,
  Input,
  Modal,
  notification,
} from 'antd'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { getAddMemberCard, getEditMemberCard, getEditMemberCardDetail } from '../MembersManagementPageSlice'

interface AddOrEditMemberCardModalProps {
  visible: boolean
  editId?: any
  onCancel: () => void
  onOk: () => void
}

export const AddOrEditMemberCardModal = ({
  visible,
  editId,
  onCancel,
  onOk,
}: AddOrEditMemberCardModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const inputRef = useRef<any>(null)

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [form] = Form.useForm()

  const { TextArea } = Input

  useEffect(() => {
    if (!visible) {
      form.resetFields()
    }
  }, [visible])

  useEffect(() => {
    if (visible) {
      if (editId) {
        dispatch(getEditMemberCardDetail({ memberCardId: editId }))
          .then(unwrapResult)
          .then((res: any) => {
            form.setFieldsValue({
              ...res,
            })
          })
      }else{
         setTimeout(() => {
          inputRef?.current?.focus()
        }, 100)
      }
    }
  }, [visible, editId])

  return (
    <Modal
      visible={visible}
      title={editId ? '会员卡编辑' : '会员卡新增'}
      width={700}
      cancelText='取消'
      okText='确定'
      confirmLoading={confirmLoading}
      maskClosable={false}
      onCancel={onCancel}
      onOk={form.submit}
    >
      <Form
        form={form}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 18 }}
        autoComplete='off'
        onFinish={(values) => {
          setConfirmLoading(true)
          const params = editId ? {
            ...values,
            cardType: 1,
            id: editId,
          } : {
            ...values,
            cardType: 1,
          }
          const save = editId ? getEditMemberCard : getAddMemberCard
          dispatch(save(params))
            .then(unwrapResult)
            .then((res) => {
              notification.success({
                message: '操作成功',
              })
              onOk && onOk()
            })
            .finally(() => {
              setConfirmLoading(false)
            })
        }}
      >

        <Form.Item
          label='会员卡号'
          name='cardNo'
          rules={[
            {
              required: true,
              message: '请输入会员卡号',
            },
            {
              pattern: new RegExp(/^[0-9]\d*$/, 'g'),
              message: "请输入正确的会员卡号",
            }
          ]}
        >
          <Input placeholder='请刷卡/输入卡号' ref={inputRef} />
        </Form.Item>
        <Form.Item
          label='会员卡金额'
          name='balance'
          rules={[
            {
              required: true,
              message: '请输入会员卡金额',
            },
          ]}
        >
          <Input type='number' placeholder='请输入卡金额' />
        </Form.Item>
        <Form.Item label='备注' name='remark'>
          <TextArea showCount maxLength={100} />
        </Form.Item>
      </Form>
    </Modal>
  )
}
